export default __webpack_public_path__ + "static/media/projectLanding.05bf5ab6.png";